export default "__VITE_ASSET__BJ9ah024__"